import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useEffect, useState } from "react";
import { encryptDecryptData } from "utils/helperFunction";
import { post } from "utils/api";
import { useSearch } from "views/Contexts/SearchContext";

const Profile = () => {
  const { userAdminData, setUserAdminData, token, setToken } = useSearch();
  const [userData, setUserData] = useState(null)
  const [userInputData, setUserInputData] = useState({})
  const [userUpdateData, setUserUpdateData] = useState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [isChanged, setIsChanged] = useState(false)

  useEffect(() => {
    if (!userData) {
      const storedData = encryptDecryptData.decrypt(localStorage.getItem("user"))
      setToken(storedData?.token) // Get token from local storage
      delete storedData?.token
      delete storedData?.id
      setUserData(storedData)
      setUserInputData(storedData) // Initialize userInputData with current data
      setUserAdminData(storedData)
    }
  }, [userData])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUserInputData(prevData => {
      const updatedData = { ...prevData, [name]: value }
      const changesMade = Object.keys(updatedData).some(key => updatedData[key] !== userData[key])
      setIsChanged(changesMade) // Check if any field is different from the original data
      return updatedData
    })
    setUserUpdateData({ ...userUpdateData, [name]: value })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      if (!userUpdateData) return

      const updatedUserData = {
        ...userData,
        ...userInputData
      }
      const header = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        }
      }

      await post('/api/admin/updateProfileData', userUpdateData, header.headers)
      localStorage.setItem("user", encryptDecryptData.encrypt(updatedUserData))
      setUserData(updatedUserData)
      setUserInputData(updatedUserData) // Sync userInputData with updated userData
      setIsChanged(false) // Reset the change status after saving
      setLoading(false)
    } catch (error) {
      setError(error.message)
      setLoading(false)
    }
  }

  return (
    <>
      <UserHeader user={userData} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
            <Card className="card-profile shadow">
              <Row className="justify-content-center">
                <Col className="order-lg-2" lg="3">
                  <div className="card-profile-image">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        className="rounded-circle"
                        src={require("../../assets/img/theme/team-4-800x800.png")}
                      />
                    </a>
                  </div>
                </Col>
              </Row>
              <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4" />
              <CardBody className="pt-0 pt-md-4">
                <Row>
                  <div className="col">
                    <div className="card-profile-stats d-flex justify-content-center mt-md-5">
                      <div className="text-center">
                        <h3>
                          {userData?.firstName} {userData?.lastName}
                        </h3>
                        {/* <div className="h5 font-weight-300">
                          <i className="ni location_pin mr-2" />
                          {userData?.address}, USA
                        </div> */}
                        <div className="h5 mt-4">
                          <i className="ni business_briefcase-24 mr-2" />
                          {userData?.role.toUpperCase()} - DRUYP OFFICER
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col className="order-xl-1 mb-4" xl="8">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">My Account</h3>
                  </Col>
                  <Col className="text-right" xs="4" />
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">User information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-username">
                            Username
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.username || ""}
                            id="input-username"
                            placeholder="Username"
                            type="text"
                            name="username"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-email">
                            Email address
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.email || ""}
                            id="input-email"
                            placeholder={userData?.email}
                            type="email"
                            name="email"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-first-name">
                            First name
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.firstName || ""}
                            id="input-first-name"
                            placeholder="First name"
                            type="text"
                            name="firstName"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-last-name">
                            Last name
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.lastName || ""}
                            id="input-last-name"
                            placeholder="Last name"
                            type="text"
                            name="lastName"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  {/* <hr className="my-4" /> */}
                  {/* Address */}
                  {/* <h6 className="heading-small text-muted mb-4">Contact information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address">
                            Address
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.address || ""}
                            id="input-address"
                            placeholder="Home Address"
                            type="text"
                            name="address"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-city">
                            City
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.city || ""}
                            id="input-city"
                            placeholder="City"
                            type="text"
                            name="city"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-country">
                            Country
                          </label>
                          <Input
                            className="form-control-alternative"
                            value="United States"
                            disabled={true}
                            id="input-country"
                            placeholder="Country"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-postal-code">
                            Postal code
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={userInputData?.postalCode || ""}
                            id="input-postal-code"
                            placeholder="Postal code"
                            type="number"
                            name="postalCode"
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div> */}
                  {/* <hr className="my-4" /> */}
                </Form>
              </CardBody>
              {isChanged  && <div className="text-center">
                <Button
                  className="btn save-button mb-4"
                  onClick={handleSubmit}
                  disabled={!isChanged || loading} // Disable the button when no changes or loading
                >
                  Save changes
                </Button>
              </div>}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profile;
